import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cash-out',
  templateUrl: './cash-out.component.html',
  styleUrls: ['./cash-out.component.scss']
})
export class CashOutComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }


  back() {
    this.router.navigate(['/']);
  }

}
